import React, { Suspense } from "react";
import { useTranslation } from "@i18n/hooks";
import { LicenseDefinitionsScreenContext } from "./license-defintions.context";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { CreateFlexLicenseDefinitionButton } from "../../features/license-definitions/create-flex-license-definition-button";
import { LicenseDefinitionsTable } from "../../features/license-definitions/license-definitions-table";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const LicenseDefinitionsScreen = () => {
	const { t } = useTranslation("common");
	const [connectionId, setConnectionId] = React.useState("");

	const canModify = useHasPermissions(["UserInAccountPermission_LicenseAdmin_Modify"]);
	const canRead = useHasPermissions(["UserInAccountPermission_LicenseAdmin_Read"]);

	const handleSetConnectionId = (id: string) => {
		setConnectionId(id);
	};

	if (!canRead) return <NoAccess />;

	return (
		<LicenseDefinitionsScreenContext.Provider
			value={{ connectionId, setConnectionId: handleSetConnectionId }}
		>
			<BaseScreen title={t("licenseDefinitions.screenTitle")}>
				{canModify && <CreateFlexLicenseDefinitionButton />}
				<Suspense fallback={<div>{t("app.loading")}</div>}>
					<LicenseDefinitionsTable />
				</Suspense>
			</BaseScreen>
		</LicenseDefinitionsScreenContext.Provider>
	);
};
